import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/layout/index.js
// module id = 798
// module chunks = 3